import { jsx as i } from "react/jsx-runtime";
import { clsx as m } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { RocheUIImage as y } from "../image/roche-image.js";
import { RocheUIImageRatio as s } from "../image/roche-image.types.js";
import e from "./roche-video-player.module.scss.js";
const x = ({
  isPlaying: a,
  fullscreen: r,
  preview: t,
  previewAlt: d,
  error: g,
  fillContainer: o,
  videoRatio: p
}) => {
  const _ = m(
    e["video-player__image"],
    o && e["video-player__image--fill"],
    r && e["video-player__image--fullscreen"],
    r && a && e["video-player__image--fullscreen-playing"],
    a && !r && e["video-player__image--hidden"]
  ), l = m(e["video-player__image"], e["video-player__image--error"]), c = g ? l : _, v = p ?? (r ? s.WIDE : s.HD);
  return /* @__PURE__ */ i("div", { className: c, "aria-hidden": !0, children: /* @__PURE__ */ i(
    y,
    {
      src: t,
      alt: d,
      ratio: v,
      fullscreen: r,
      fillContainer: o
    }
  ) });
};
export {
  x as RocheUIVideoPlayerPreviewImage
};
